import { render } from "./SellerChat.vue?vue&type=template&id=2501a562&scoped=true"
import script from "./SellerChat.vue?vue&type=script&lang=js"
export * from "./SellerChat.vue?vue&type=script&lang=js"

import "./SellerChat.vue?vue&type=style&index=0&id=2501a562&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2501a562"]])

export default __exports__